/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const AgencyFinalEvaluation = {

	delete (context, finalEvaluationId, onSuccess, onError, options) {
		Api.delete(context,
			"/agency-final-evaluation"
			+ "?finalEvaluationId=" + finalEvaluationId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	get (context, finalEvaluationId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-final-evaluation"
			+ "?finalEvaluationId=" + finalEvaluationId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getConfiguration (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-final-evaluation/configuration"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestNames (context, onSuccess, onError, options) {
		Api.get(context,
			"/agency-final-evaluation/contest-names"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postTeamUser (context, agencyProjectId, teamUserId, onSuccess, onError, options) {
		Api.post(context,
			"/agency-final-evaluation/team-user"
			+ "?agencyProjectId=" + agencyProjectId
			+ "&teamUserId=" + teamUserId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, finalEvaluationId, onSuccess, onError, options) {
		Api.put(context,
			"/agency-final-evaluation"
			+ "?finalEvaluationId=" + finalEvaluationId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putCorrection (context, evaluationId, correctionCauseDTO, onSuccess, onError, options) {
		Api.put(context,
			"/agency-final-evaluation/correction"
			+ "?evaluationId=" + evaluationId
			, correctionCauseDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putData (context, finalEvaluationId, agencyFinalEvaluationDTO, onSuccess, onError, options) {
		Api.put(context,
			"/agency-final-evaluation/data"
			+ "?finalEvaluationId=" + finalEvaluationId
			, agencyFinalEvaluationDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFinish (context, finalEvaluationId, agencyFinalEvaluationDTO, onSuccess, onError, options) {
		Api.put(context,
			"/agency-final-evaluation/finish"
			+ "?finalEvaluationId=" + finalEvaluationId
			, agencyFinalEvaluationDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
